<template>
  <DefaultBackground>
    <section class="m-2 md:m-10">
      <div class="container mx-auto">
        <DefaultCard>
          <Heading>
            <template>Promo Instances</template>
            <template v-slot:right>
              <StyledButton
                type="primary"
                size="md"
                @click="showCreatePromotionModal = true"
              >
                Create
              </StyledButton>
            </template>
          </Heading>

          <TableComponent
            class="mt-8"
            v-if="events"
            :data="events"
            :keys="['name', 'url', 'status']"
            :headers="['Name', 'Url', 'Status']"
          >
            <template v-slot:buttons="{ row }">
              <router-link :to="'/promotions/' + row.id + '/details'">
                <StyledButton size="xs">View</StyledButton>
              </router-link>
            </template>
          </TableComponent>
        </DefaultCard>
      </div>
    </section>

    <CreateUpdatePromotionModal
      v-if="showCreatePromotionModal"
      @close="showCreatePromotionModal = false"
    />
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground";
import DefaultCard from "@/components/common/layout/DefaultCard";
import Heading from "@/components/common/Heading";
import TableComponent from "@/components/common/TableComponent";
import StyledButton from "@/components/common/controls/StyledButton";
import CreateUpdatePromotionModal from "@/components/modals/promotion/CreateUpdatePromotionModal";
import ApiV1 from "@/api/api_v1.0";

export default {
  name: "promotionIndex",
  components: {
    DefaultBackground,
    DefaultCard,
    Heading,
    TableComponent,
    StyledButton,
    CreateUpdatePromotionModal
  },
  data() {
    return {
      events: null,
      showCreatePromotionModal: false
    };
  },

  async created() {
    const response = await ApiV1.getPromotions();
    this.events = response.data.length > 0 ? response.data : null;
  }
};
</script>

<style></style>
